import baseTheme from '../baseTheme';
var MuiDialogActions = {
    /* your custom class style overrides here */
    root: {
        position: 'relative',
        paddingLeft: baseTheme.spacing(3),
        paddingRight: baseTheme.spacing(3),
        paddingTop: baseTheme.spacing(2),
        paddingBottom: baseTheme.spacing(2),
    },
    spacing: {
        '& > * + *': {
            marginLeft: baseTheme.spacing(2),
        },
    },
};
export default MuiDialogActions;
//# sourceMappingURL=MuiDialogActions.js.map